import { Fields } from '@measured/puck';
import NewMarginFiled from './newMarginField';

export type MarginType = {
  marginTop: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  marginBottom: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  marginLeft: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  marginRight: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  deviceType: string;
};

export type MarginProps = {
  margin: MarginType;
};
export const marginProps: MarginProps = {
  margin: {
    deviceType: 'desktop',
    marginBottom: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
    marginLeft: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
    marginRight: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
    marginTop: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
  },
};
export const marginFields: Fields<MarginProps> = {
  margin: {
    type: 'custom',
    label: 'Margin',
    render: ({ value, onChange }) => (
      <NewMarginFiled value={value} onChange={onChange} title="Margin" />
    ),
  },
};
